import { CallHistoryService } from './socket-call-history';

export interface ApiCallHistoryService {
    AddNewRecord(data: any): Promise<any>;
    GetListByAgentRef(agentIdNumber: number): Promise<any>;
}

export const socketCallHistory = new CallHistoryService();